
export class VisitLookup {

    static GetVisit(id: number): string {
        switch (id) {
            case (1): return "Screening";
            case (2): return "Baseline";
            case (3): return "Mid-Intervention";
            case (4): return "End of Intervention";
            case (5): return "Day 45";
            case (6): return "Day 60";
            case (7): return "Day 90";
            case (8): return "Day 120";
            case (9): return "End of Follow-Up";      
            case (10): return "Start of Intervention";
            case (11): return "Week 1";
            case (12): return "Week 2";
            case (13): return "Week 3";
            case (14): return "Week 4";
            case (15): return "Week 5";
            case (16): return "Week 7";
            case (17): return "Week 9";
            case (18): return "Week 10";
            case (19): return "Week 11";
            case (20): return "Week 13";
            case (21): return "Week 14";
            case (22): return "Week 15";
            case (23): return "Week 17";
            case (24): return "Week 18";
            case (25): return "Week 19";
            case (26): return "Week 20";
            case (27): return "Week 21";
            case (28): return "Week 22";
            case (29): return "Week 23";
            case (30): return "Week 24";
            case (31): return "Week 25";
            case (32): return "Week 26";
            case (33): return "Week 27";
            case (34): return "Week 28";
            case (35): return "Week 29";
            case (36): return "Week 30";
            case (37): return "Week 31";
            case (38): return "Week 32";
            case (39): return "Week 33";
            case (40): return "Week 34";
            case (41): return "Week 35";
            case (42): return "Week 6";
            case (43): return "Week 8";
            case (44): return "Week 12";
            case (45): return "Week 16";
            case (46): return "Week 2 (CPSD)";
            case (48): return "Week 5 (CPSD)";
            case (49): return "Week 7 (CPSD)";
            case (50): return "Day 1";
            default: return "Unknown";
        }
    }

    static GetVisitOrdering(id: number): number {
        switch (id) {
            case (1): return 1; //"Screening";
            case (2): return 2; //"Baseline";
            case (10): return 3; //"Start of Intervention";
            case (50): return 4; //Day 1
            case (3): return 5; //"Mid-Intervention";
            case (11): return 6; //"Week 1";
            case (12): return 7; //"Week 2";
            case (46): return 8; //"Week 2 (CPSD)"
            case (13): return 9; //"Week 3";
            case (14): return 10; //"Month 1";
            case (15): return 11; //"Week 5";
            case (48): return 12; //Week 5 (CPSD)
            case (42): return 13; //"Week 6";
            case (16): return 14; //"Week 7";
            case (49): return 15; //"Week 7 (CPSD";
            case (43): return 16; //"Month 2";
            case (17): return 17; //"Week 9";
            case (18): return 18; //"Week 10";
            case (19): return 19; //"Week 11";
            case (44): return 20; //"Month 3";
            case (20): return 21; //"Week 13";
            case (21): return 22; //"Week 14";
            case (22): return 23; //"Week 15";
            case (45): return 24; //"Month 4";
            case (23): return 25; //"Week 17";
            case (24): return 26; //"Week 18";
            case (25): return 27; //"Week 19";
            case (26): return 28; //"Month 5";
            case (27): return 29; //"Week 21";
            case (28): return 30; //"Week 22";
            case (29): return 31; //"Week 23";
            case (30): return 32; //"Month 6";
            case (31): return 33; //"Week 25";
            case (32): return 34; //"Week 26";
            case (33): return 35; //"Week 27";
            case (34): return 36; //"Month 7";
            case (35): return 37; //"Week 29";
            case (36): return 38; //"Week 30";
            case (37): return 39; //"Week 31";
            case (38): return 40; //"Month 8";
            case (39): return 41; //"Week 33";
            case (40): return 42; //"Week 34";
            case (41): return 43; //"Week 35";
            case (4): return 44; //"End of Intervention";
            case (5): return 45; //"Day 45";
            case (6): return 46; //"Day 60";
            case (7): return 47; //"Day 90";
            case (8): return 48; //"Day 120";
            case (9): return 49; //"End of Follow-Up";      
            default: return 100; // "Unknown";
        }
    }

    static GetVisitMasterOrdering(id: number): number {
        switch (id) {
            case 1: return 1;  // SCREEN
            case 2: return 2;   // BASE           
            case 11: return 3;   // SOI
            case 58: return 4; // day 1
            case 3: return 5;   // MOI
            case 12: return 6;   // week 1
            case 13: return 7; // WEEK 1.5
            case 14: return 8; // WEEK 2
            case 59: return 9; // "Week 2 (CPSD)"
            case 15: return 10; // WEEK 2.5
            case 16: return 11; // WEEK 3
            case 17: return 12; // WEEK 3.5
            case 18: return 13; // WEEK 4
            case 19: return 14; // WEEK 4.5
            case 21: return 15; // WEEK 5
            case 60: return 16; // "Week 5 (CPSD)"
            case 21: return 17; // WEEK 5.5
            case 22: return 18; // WEEK 6
            case 23: return 19; // WEEK 6.5
            case 24: return 20; // WEEK 7
            case 61: return 21; // "Week 7 (CPSD)"
            case 25: return 22; // WEEK 7.5
            case 26: return 23; // WEEK 8
            case 27: return 24; // WEEK 8.5
            case 28: return 29; // WEEK 9
            case 29: return 30; // WEEK 9.5
            case 30: return 31; // WEEK 10
            case 31: return 32; // WEEK 10.5
            case 32: return 33; // WEEK 11
            case 33: return 34; // WEEK 11.5
            case 34: return 35; // WEEK 12 / 3 Months
            case 35: return 36; // WEEK 13
            case 36: return 37; // WEEK 14
            case 37: return 38; // WEEK 15
            case 38: return 39; // "Week 16/Month 4"
            case 39: return 40; // WEEK 17
            case 40: return 41; // WEEK 18
            case 41: return 42; // WEEK 19
            case 42: return 43; // WEEK 20
            case 43: return 44; // WEEK 21
            case 44: return 45; // WEEK 22
            case 45: return 46; // WEEK 23
            case 46: return 47; // WEEK 24
            case 47: return 48; // WEEK 25
            case 48: return 49; // WEEK 26
            case 49: return 50; // WEEK 27
            case 50: return 51; //"Week 28";
            case 51: return 52; //"Week 29";
            case 52: return 53; //"Week 30";
            case 53: return 54; //"Week 31";
            case 54: return 55; //"Week 32";
            case 55: return 56; //"Week 33";
            case 56: return 57; //"Week 34";
            case 57: return 58; //"Week 35";
            case 4: return 59; //"End of Intervention";
            case 5: return 60; //"Day 45";
            case 6: return 61; //"Day 60";
            case 7: return 62; //"Day 90";
            case 8: return 63; //"Day 120";
            case 9: return 64; //"End of study";    
            case 10: return 65; // end of follow up
            default: return 100; // Unknown
        }
    }

    static GetVisitMasterColumn(id: number): string {
        switch (id) {
            case 1: return "Screening";
            case 2: return "Baseline";
            case 3: return "Mid-Intervention";
            case 4: return "End of Intervention";
            case 5: return "Day 45";
            case 6: return "Day 60";
            case 7: return "Day 90";
            case 8: return "Day 120";
            case 9: return "End of Study";
            case 10: return "Follow-Up";
            case 11: return "Start of Intervention";
            case 12: return "Week 1";
            case 13: return "Week 1.5";
            case 14: return "Week 2";
            case 15: return "Week 2.5";
            case 16: return "Week 3";
            case 17: return "Week 3.5";
            case 18: return "Week 4/Month 1";
            case 19: return "Week 4.5";
            case 20: return "Week 5";
            case 21: return "Week 5.5";
            case 22: return "Week 6/Month 2";
            case 23: return "Week 6.5";
            case 24: return "Week 7";
            case 25: return "Week 7.5";
            case 26: return "Week 8";
            case 27: return "Week 8.5";
            case 28: return "Week 9";
            case 29: return "Week 9.5";
            case 30: return "Week 10";
            case 31: return "Week 10.5";
            case 32: return "Week 11";
            case 33: return "Week 11.5";
            case 34: return "Week 12/Month 3";
            case 35: return "Week 13";
            case 36: return "Week 14";
            case 37: return "Week 15";
            case 38: return "Week 16/Month 4";
            case 39: return "Week 17";
            case 40: return "Week 18";
            case 41: return "Week 19";
            case 42: return "Week 20";
            case 43: return "Week 21";
            case 44: return "Week 22";
            case 45: return "Week 23";
            case 46: return "Week 24";
            case 47: return "Week 25";
            case 48: return "Week 26";
            case 49: return "Week 27";
            case 50: return "Week 28";
            case 51: return "Week 29";
            case 52: return "Week 30";
            case 53: return "Week 31";
            case 54: return "Week 32";
            case 55: return "Week 33";
            case 56: return "Week 34";
            case 57: return "Week 35";
            case 58: return "Day 1";
            case 59: return "Week 2 (CPSD)";
            case 60: return "Week 5 (CPSD)";
            case 61: return "Week 7 (CPSD)";
            default: return "Unknown";
        }
    }

    static GetRequired(id: number): string {
        switch (id) {
            case (1): return "Yes";
            case (2): return "No";
            default: return "Unknown";
        }
    }

    static GetVisitStatus(id: number): string {
        switch (id) {
            case (1): return "Completed";
            case (2): return "Not Yet Due";
            case (3): return "Overdue";
            case (4): return "Not Done";
            case (5): return "Discontinued Prior";
            case (6): return "Not Yet Due (≤30 Days)";
            case (7): return "Not Yet Due (+30 Days)";
            case (20): return "In Window";
            case (21): return "± 1 - 3 Days";
            case (22): return "± 4 - 7 Days";
            case (23): return "± 8 - 14 Days";
            case (24): return "15+ Days";
            default: return "Unknown";
        }
    }

    static GetVisitColorIndex(id: number): number {
        switch (id) {
            case (1): return 500; //Completed
            case (2): return 501; //Not Yet Due
            case (3): return 502; //Overdue
            case (4): return 503; //Not Done
            case (5): return 504; //Discontinued Prior
            case (6): return 501; //Not Yet Due <= 30 Days
            case (7): return 505; //Not Yet Due > 30 Days
            case (20): return 500; //In Window
            case (21): return 501; //1 to 3 Days Outside Window
            case (22): return 502; //4 to 7 Days Outside Window
            case (23): return 503; //8 to 14 Days Outside Window
            case (24): return 504; //15 or More Days Outside Widow
            default: return 0;
        }
    }

    //static GetVisitStatusArray(): string[] {
    //    return [ "Completed", "Overdue", "Not Done", "Discontinued Prior", "Not Yet Due" ];
    //}

    //static GetCompletionTimingArray(): string[] {
    //    return ["In Window", "1 to 3 Days Outside Window", "4 to 7 Days Outside Window", "8 to 14 Days Outside Window", "15 or More Days Outside Widow"];
    //}
}